import React from "react";

const FarmersVideo = () => {
  const videostyle = `
.farmers-section {
  text-align: center;
  padding: var(--space-lg) var(--space-md);
  background: linear-gradient(to bottom, var(--color-accent), var(--color-secondary));
}

.farmers-title {
  // font-size: var(--font-xl);
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: var(--space-lg);
  font-family: var(--font-primary);
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 950px;
  margin: 0 auto;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: var(--border-radius-card);
  // box-shadow: var(--box-shadow-card);
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70%;
  border: none;
  border-radius: var(--border-radius-card);
}
`;

  return (
    <>
      <style>{videostyle}</style>   
      <div className="farmers-section">
        <h1 className="farmers-title">
          We Are Farmers, Growing Honest Food With Love & Care
        </h1>

        <div className="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/-Z-_mVpqQ94?si=OCD-L4dQqWywi3hh"
            title="Farmers Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default FarmersVideo;
